module.exports = __webpack_public_path__ + "img/ship.060886d4.svg";